import React from "react";

export const PageContainer = ({children, type = "white"}) => {

    return <div className="bg-white text-gray-800 h-screen pl-4 pt-2">

        {children}
    </div>
}
